import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { motion } from "framer-motion";
import { Home, Compass, Car } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageHero from "@/components/PageHero";
import { Button } from "@/components/ui/button";
import { useSeo } from "@/hooks/useSeo";
import heroImg from "@/assets/hero-caribbean.jpg";

const NotFound = () => {
  const location = useLocation();
  useSeo({ robots: "noindex,follow", title: "Page Not Found | Allen Travels RD" });

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-gradient-soft flex flex-col">
      <Navbar />
      <PageHero
        eyebrow="404"
        title={<>This route hasn't been mapped <span className="text-gradient-sunset">yet</span></>}
        subtitle="The page you're looking for drifted off course. Let's get you back to paradise."
        image={heroImg}
        align="center"
        size="sm"
      >
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="flex flex-wrap justify-center gap-3"
        >
          <Button asChild size="lg" className="bg-gradient-ocean text-white shadow-elegant hover:opacity-95">
            <Link to="/"><Home className="w-4 h-4 mr-2" />Back home</Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="bg-white/10 border-white/30 text-white hover:bg-white/20">
            <Link to="/tours"><Compass className="w-4 h-4 mr-2" />Browse tours</Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="bg-white/10 border-white/30 text-white hover:bg-white/20">
            <Link to="/transfers"><Car className="w-4 h-4 mr-2" />Book a transfer</Link>
          </Button>
        </motion.div>
      </PageHero>
      <Footer />
    </div>
  );
};

export default NotFound;
